var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildings2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/buildings-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buildings-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.70001 18.75H4.15002C2.31002 18.75 1.25 17.69 1.25 15.85V4.15002C1.25 2.31002 2.31002 1.25 4.15002 1.25H8.45001C10.29 1.25 11.35 2.31002 11.35 4.15002V6C11.35 6.41 11.01 6.75 10.6 6.75C10.19 6.75 9.84998 6.41 9.84998 6V4.15002C9.84998 3.13002 9.47001 2.75 8.45001 2.75H4.15002C3.13002 2.75 2.75 3.13002 2.75 4.15002V15.85C2.75 16.87 3.13002 17.25 4.15002 17.25H6.70001C7.11001 17.25 7.45001 17.59 7.45001 18C7.45001 18.41 7.11001 18.75 6.70001 18.75Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9631 22.75H9.12311C7.11311 22.75 5.95312 21.59 5.95312 19.58V8.41998C5.95312 6.40998 7.11311 5.25 9.12311 5.25H14.9631C16.9731 5.25 18.1231 6.40998 18.1231 8.41998V19.58C18.1231 21.59 16.9731 22.75 14.9631 22.75ZM9.12311 6.75C7.92311 6.75 7.45312 7.21998 7.45312 8.41998V19.58C7.45312 20.78 7.92311 21.25 9.12311 21.25H14.9631C16.1531 21.25 16.6231 20.78 16.6231 19.58V8.41998C16.6231 7.21998 16.1531 6.75 14.9631 6.75H9.12311Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.8484 18.75H17.3684C16.9584 18.75 16.6184 18.41 16.6184 18C16.6184 17.59 16.9584 17.25 17.3684 17.25H19.8484C20.8684 17.25 21.2484 16.87 21.2484 15.85V4.15002C21.2484 3.13002 20.8684 2.75 19.8484 2.75H15.5484C14.5284 2.75 14.1484 3.13002 14.1484 4.15002V6C14.1484 6.41 13.8084 6.75 13.3984 6.75C12.9884 6.75 12.6484 6.41 12.6484 6V4.15002C12.6484 2.31002 13.7084 1.25 15.5484 1.25H19.8484C21.6884 1.25 22.7484 2.31002 22.7484 4.15002V15.85C22.7484 17.69 21.6884 18.75 19.8484 18.75Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14 11.75H10C9.59 11.75 9.25 11.41 9.25 11C9.25 10.59 9.59 10.25 10 10.25H14C14.41 10.25 14.75 10.59 14.75 11C14.75 11.41 14.41 11.75 14 11.75Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14 14.75H10C9.59 14.75 9.25 14.41 9.25 14C9.25 13.59 9.59 13.25 10 13.25H14C14.41 13.25 14.75 13.59 14.75 14C14.75 14.41 14.41 14.75 14 14.75Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12 22.75C11.59 22.75 11.25 22.41 11.25 22V19C11.25 18.59 11.59 18.25 12 18.25C12.41 18.25 12.75 18.59 12.75 19V22C12.75 22.41 12.41 22.75 12 22.75Z",
    fill: "#B0BECF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings2);
export default __webpack_public_path__ + "static/media/buildings-2.400fa969a5982994d464ef1b76593641.svg";
export { ForwardRef as ReactComponent };